export type DealerPortalLanguage = "en" | "am";

export const DEALER_LANGUAGE_KEY = "dealerPortalLanguage";

export const getSavedDealerLanguage = (): DealerPortalLanguage =>
  localStorage.getItem(DEALER_LANGUAGE_KEY) === "am" ? "am" : "en";

export const saveDealerLanguage = (language: DealerPortalLanguage) => {
  localStorage.setItem(DEALER_LANGUAGE_KEY, language);
};

export const dealerPortalCopy = {
  en: {
    languageToggle: "አማ",
    loginTitle: "BossCar car seller portal",
    loginDescription: "Send available cars to BossCar staff.",
    phone: "Phone number",
    password: "Password",
    loginError: "Unable to login",
    signingIn: "Signing in...",
    signIn: "Sign in",
    kicker: "BossCar car seller portal",
    intro: "Send photos and price. BossCar will finish the post.",
    heroTitle: "Send your car to BossCar",
    heroLineOne: "Add photos and price.",
    heroLineTwo: "We'll handle the rest.",
    logout: "Logout",
    photosStep: "Photos",
    photosStepHint: "Add at least 4 photos",
    carPhotos: "Choose photos",
    carPhotosHint: "Front, back, interior, and useful car detail.",
    detailPhoto: "Car detail",
    detailPhotoHint: "Upload any useful close-up photo.",
    chooseGallery: "Choose photos from gallery",
    extraPhotos: "Extra gallery photos",
    frontPhoto: "Front",
    backPhoto: "Back",
    interiorPhoto: "Interior",
    detailPhotoSlot: "Car detail",
    optionalDetails: "Add full details yourself",
    optionalDetailsHint: "If you skip this, BossCar will complete it.",
    optionalDetailsToggle: "Add full details yourself",
    makeModelText: "Car name / Model",
    year: "Year",
    color: "Color",
    fuelType: "Fuel type",
    selectFuelType: "Fuel type",
    price: "Price",
    priceHint: "Enter the asking price",
    note: "Note (optional)",
    sendStep: "Send to BossCar",
    sendHint: "We will review and post it.",
    trustText: "Your info is safe and used only for posting.",
    send: "Send to BossCar",
    update: "Update submission",
    cancel: "Cancel edit",
    sentTitle: "Sent!",
    sentBody: "BossCar will review and post it soon. Thank you.",
    quickSendAnother: "Quick send another one",
    saved: "Sent. BossCar staff will review it.",
    updated: "Updated.",
    priceRequired: "Enter the asking price.",
    missingPhotos: "Please add the 4 photos.",
    disabledNeedPhotos: "Add the 4 photos to send.",
    disabledNeedPrice: "Enter price to send.",
    submissions: "My sent cars",
    viewAll: "View all sent cars",
    hideList: "Hide list",
    empty: "No sent cars yet.",
    edit: "Edit",
    delete: "Delete",
    sold: "Mark sold",
    status: "Status",
    staffNote: "Staff note",
    deleteConfirm: "Delete this unpublished submission?",
    searchSubmissions: "Search your sent cars",
    filterAll: "All",
    filterSubmitted: "Sent",
    filterNeedsInfo: "Needs info",
    filterPublished: "Published",
    filterSold: "Sold",
    filterRejected: "Rejected",
    noMatchingSubmissions: "No sent cars match this filter.",
    photosReady: "Photos ready",
    photosMissing: "Photos missing",
    updatedAt: "Updated",
    clear: "Clear",
    refresh: "Refresh",
    editing: "Editing submission",
    newSubmission: "New car submission",
  },
  am: {
    languageToggle: "En",
    loginTitle: "የBossCar የመኪና ሻጭ ፖርታል",
    loginDescription: "ያሉዎትን መኪናዎች ለBossCar ሰራተኞች ይላኩ።",
    phone: "ስልክ ቁጥር",
    password: "የይለፍ ቃል",
    loginError: "መግባት አልተቻለም",
    signingIn: "በመግባት ላይ...",
    signIn: "ግባ",
    kicker: "የBossCar የመኪና ሻጭ ፖርታል",
    intro: "ፎቶና ዋጋ ይላኩ። BossCar ፖስቱን ያጠናቅቃል።",
    heroTitle: "መኪናዎን ወደ BossCar ይላኩ",
    heroLineOne: "ፎቶዎችን እና ዋጋ ያስገቡ።",
    heroLineTwo: "ቀሪውን BossCar ያሟላዋል።",
    logout: "ውጣ",
    photosStep: "ፎቶዎች",
    photosStepHint: "4 ፎቶዎች ቢያንስ ያክሉ",
    carPhotos: "ፎቶዎች",
    carPhotosHint: "4 ፎቶዎች ቢያንስ ያክሉ",
    detailPhoto: "የመኪና ዝርዝር",
    detailPhotoHint: "ማንኛውንም ጠቃሚ የቅርብ ፎቶ ያክሉ።",
    chooseGallery: "ፎቶዎችን ከጋለሪ ይምረጡ",
    extraPhotos: "ተጨማሪ ፎቶዎች",
    frontPhoto: "ፊት",
    backPhoto: "ኋላ",
    interiorPhoto: "ውስጥ",
    detailPhotoSlot: "የመኪና ዝርዝር",
    optionalDetails: "ሙሉ መረጃውን እርስዎ ያክሉ",
    optionalDetailsHint: "ካልጨመሩ BossCar ያሟላዋል",
    optionalDetailsToggle: "ሙሉ መረጃውን እርስዎ ያክሉ",
    makeModelText: "የመኪና ስም / ሞዴል",
    year: "አመት",
    color: "ቀለም",
    fuelType: "የነዳጅ አይነት",
    selectFuelType: "የነዳጅ አይነት",
    price: "ዋጋ",
    priceHint: "የሚፈልጉትን ዋጋ ያስገቡ",
    note: "ማስታወሻ (አማራጭ)",
    sendStep: "ወደ BossCar ይላኩ",
    sendHint: "እንመለከታለን እና እንፖስታለን።",
    trustText: "መረጃዎ ለፖስት ብቻ ይጠቀማል።",
    send: "ወደ BossCar ይላኩ",
    update: "አዘምን",
    cancel: "ሰርዝ",
    sentTitle: "ተልኳል!",
    sentBody: "BossCar ይመለከተዋል እና በቅርቡ ይፖስታል። እናመሰግናለን።",
    quickSendAnother: "ሌላ መኪና በፍጥነት ይላኩ",
    saved: "ተልኳል። BossCar ሰራተኞች ይመለከቱታል።",
    updated: "ተዘምኗል።",
    priceRequired: "የሚፈልጉትን ዋጋ ያስገቡ።",
    missingPhotos: "እባክዎ 4 ፎቶዎችን ያክሉ።",
    disabledNeedPhotos: "ለመላክ 4 ፎቶዎችን ያክሉ።",
    disabledNeedPrice: "ለመላክ ዋጋ ያስገቡ።",
    submissions: "የላኩት መኪናዎች",
    viewAll: "ሁሉንም ይመልከቱ",
    hideList: "ዝርዝሩን ዝጋ",
    empty: "እስካሁን የተላከ መኪና የለም።",
    edit: "አስተካክል",
    delete: "ሰርዝ",
    sold: "ተሽጧል በል",
    status: "ሁኔታ",
    staffNote: "የሰራተኛ ማስታወሻ",
    deleteConfirm: "ይህን ያልታተመ መኪና መሰረዝ ይፈልጋሉ?",
    searchSubmissions: "የላኩትን መኪና ይፈልጉ",
    filterAll: "ሁሉም",
    filterSubmitted: "ተልኳል",
    filterNeedsInfo: "መረጃ ይፈልጋል",
    filterPublished: "ታትሟል",
    filterSold: "ተሽጧል",
    filterRejected: "ተመልሷል",
    noMatchingSubmissions: "ከዚህ ማጣሪያ ጋር የሚዛመድ መኪና የለም።",
    photosReady: "ፎቶዎች ተዘጋጅተዋል",
    photosMissing: "ፎቶ ይቀራል",
    updatedAt: "ተዘምኗል",
    clear: "አጽዳ",
    refresh: "አድስ",
    editing: "መኪና በማስተካከል ላይ",
    newSubmission: "አዲስ መኪና ላክ",
  },
} as const;
